import Vue from "vue";
import Login from './login.vue';
import i18n from '../../il8n/index';
import router from '../../router/index';

export var showLogin = (function() {
    return function(options) {

        let defaults = {
            show: false
        }
        var Profile = Vue.extend(Login);
        for (let key in options) {
            defaults[key] = options[key];
        }

        let {
            show
        } = defaults;
        let profile = new Profile({
            el: document.createElement("div"),
            i18n,
            router,
            data() {
                return {
                    show
                }
            },
            methods: {
                //   cancel() {
                //     defaults.cancel && defaults.cancel.call(this);
                //     document.body.removeChild(profile.$el);
                //   }
            }
        });
        // 创建 Profile 实例，并挂载到一个元素上。

        document.body.appendChild(profile.$el);

    }


})();